module.exports = __webpack_public_path__ + "img/ai4 (1).07a97be8.png";